<template>
    <section class="panel-body">
        <form-wizard :startIndex="0" color="#0074D9" stepSize="xs" ref="wizard" :title="''" :subtitle="''"
            shape="circle">
            <tab-content v-if="empresaLogada.emp_status === 'E'" title="Plano Expirado" icon="fa fa-frown-o">
                <div class="alert bg-red alert-dismissible">
                    <p><strong><i class="icon fa fa-warning"></i> Seu plano expirou
                        </strong></p>
                    <p>Selecione um plano para continuar.</p>
                </div>
                <div class="col-md-12">
                    <div>
                        <h4><i class="fa fa-info-circle"></i> Para dúvidas, entre em contato com o suporte.</h4>
                        <p>Telefone: (12) 3152-9360 e (12) 9 7404-9319 <i class="text-green fa fa-whatsapp"></i></p>
                        <p>E-mail: suporte@mbd.com.br</p>
                        <p><i class="text-aqua fa fa-skype"></i> Skype: suporte@mbd.com.br</p>
                    </div>
                </div>
            </tab-content>
            <p class="callout alert-light m-0">Preencher os dados abaixo para contratação da Plataforma de Assinatura
                Eletrônica e Gerenciamento de Documentos Digitais.</p>{{empresaLogada.emp_status}}
            <tab-content title="Empresa" icon="fa fa-building" v-if="!empresaLogada.id || !empresaLogada.empresa_ibge"
                :before-change="validateCompany">
                <div class="row my-3 mx-0 align-items-center callout-x">
                    <register-company ref="TabCompany" :dados="dados" />
                </div>
            </tab-content>
            <tab-content title="Selecionar Plano" icon="fa fa-tag" :before-change="validatePlano">
                <table-plano ref="TabPlano" :render="{periocidade, choicePlan}"></table-plano>
            </tab-content>
            <tab-content title="Assinatura" icon="fa fa-calendar" :before-change="validateAsing">
                <div class="row my-3 mx-0 px-0 pt-0 pb-5 align-items-center callout-x">
                    <div class="col-md-8 px-0 mx-auto">
                        <register-asign ref="TabAsing" :dados="dados" v-if="selectedPlano"
                            :selectedPlano="selectedPlano" @selectRecorrencia="selectRecorrencia" />
                    </div>
                    <div class="col-md-3">
                        <register-store :dados="dados" :selectedPlano="selectedPlano" />
                    </div>
                </div>
            </tab-content>
            <tab-content title="Adicionais" icon="fa fa-plus">
                <div class="row mx-0 my-3 align-items-center callout-x">
                    <div class="col-md-8 mx-auto my-5">
                        <register-plus :dados="dados" :selectedPlano="selectedPlano" />
                    </div>
                    <div class="col-md-3">
                        <register-store :dados="dados" :selectedPlano="selectedPlano" />
                    </div>
                </div>
            </tab-content>
            <tab-content title="Pagamento" icon="fa fa-check">
                <div class="row mx-0 my-3 align-items-center callout-x">
                    <div class="col-md-6 px-2 px-md-5 mx-auto alert-light rounded">
                        <card-form ref="TabPayment" :payment="dados.selected" />
                    </div>
                    <div class="col-md-4">
                        <register-store :dados="dados" :selectedPlano="selectedPlano" />
                    </div>
                </div>
                <p class="callout alert-light w-100 mt-3 mb-0">
                    Após a confirmação será enviado um e-mail de boas-vindas com instruções de acesso e link para nosso
                    canal de treinamento.</p>
            </tab-content>
            <button type="button" class="btn-wizard btn btn-primary" slot="prev"> VOLTAR </button>
            <button type="button" class="btn-wizard btn btn-primary" slot="next"> PROXIMO
                <i v-show="dados.loading" @click="send" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
            <button @click="send" type="button" :disabled="dados.loading" class="btn-wizard btn btn-success"
                slot="finish">
                <i class="fa fa-check"></i>
                CONFIRMAR
                <i v-show="dados.loading" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
        </form-wizard>
    </section>
</template>

<script>
    import {
        FormWizard,
        TabContent
    } from "vue-form-wizard";
    import TablePlano from '../home/components/table-plano.vue';
    import RegisterPlus from '../home/components/register-plus.vue';
    import RegisterAsign from '../home/components/register-asign.vue';
    import CardForm from '../home/components/card-form.vue';
    import RegisterStore from '../home/components/register-store.vue';
    import RegisterCompany from '../home/components/register-company.vue';
    export default {
        name: 'page402',
        components: {
            FormWizard,
            TabContent,
            TablePlano,
            RegisterPlus,
            RegisterAsign,
            CardForm,
            RegisterStore,
            RegisterCompany
        },
        data() {
            return {
                periocidade: 'false',
                dados: {
                    adicionais: [],
                    loaded: true,
                    loading: false,
                    request: {},
                    settings: {
                        dots: true,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        initialSlide: 0,
                        centerPadding: "20px",
                        responsive: [{
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    infinite: true,
                                    dots: true,
                                },
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    initialSlide: 2,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    },
                    selected: {
                        fk_plano_id: null,
                        fk_validade_id: "",
                        planoValor: 0,
                        cardName: "",
                        cardNumber: "",
                        cardMonth: null,
                        cardYear: null,
                        cardCvv: "",
                        grecaptcha: "",
                        documento: "",
                        fantasia: "",
                        cep: "",
                        endereco: "",
                        numero: "",
                        bairro: "",
                        cidade: null,
                        estado: null,
                        pais: "1058",
                        complemento: "",
                        adicionais: [],
                    },
                },
            };
        },
        computed: {
            selectedPlano() {
                return this.$store.state.plano.selectedPlano;
            },
            expired() {
                return this.auth_user.ambiente == 'S' || !this.empresaLogada.plano.recorrente ||
                    this.empresaLogada.plano.ck_tipo == 'D';
            }
        },
        watch: {
            $route(data) {
                if (data.name != 'comprar')
                    this.$destroy();
            },
        },
        beforeMount() {
            if (!this.expired) {
                this.$router.push('/home');
            }
        },
        mounted() {
            this.dados.selected.fantasia = this.empresaLogada.empresa_nome;
            this.dados.selected.documento = this.empresaLogada.empresa_documento;
            this.dados.selected.telefone = this.auth_user.telefone;
            console.log(this.auth_user);
            this.$store.dispatch('getResale', window.location.hostname)
                .then(response =>
                    this.dados.selected.id_revenda = response.id
                )
        },
        methods: {
            validateCompany() {
                return this.$refs.TabCompany.validate();
            },
            validatePlano() {
                return this.$refs.TabPlano.validate();
            },
            validateAsing() {
                return this.$refs.TabAsing.validate();
            },
            validatePayment() {
                return this.$refs.TabPayment.validate();
            },
            selectRecorrencia(payload) {
                if (this.$refs.wizard) {
                    //this.$refs.wizard.changeTab(1, 2);
                }
            },
            choicePlan(payload) {
                this.$store.commit('SET_PLANO_SELECTED', payload);
                this.dados.selected.fk_validade_id = '';
            },
            async send() {
                let valid = await this.validatePayment();
                if (!valid) {
                    return
                }
                this.dados.selected.fk_plano_id = this.selectedPlano.id;
                if (!this.dados.selected.fk_plano_id) {
                    toastr({
                        icon: 'error',
                        title: 'Escolha um plano!'
                    });
                    this.$refs.wizard.changeTab(3, 0);
                    return;
                }
                if (!this.dados.selected.fk_validade_id) {
                    toastr({
                        icon: 'error',
                        title: 'Escolha uma assinatura!'
                    });
                    this.$refs.wizard.changeTab(3, 0);
                    return;
                }
                this.dados.selected.grecaptcha = await this.$recaptcha("CadastroDocx").then(token => {
                    return token;
                });
                this.dados.selected.tokenId = this.$route.params.tokenId;
                this.dados.loading = true;

                this.$store.dispatch('reativarDocx', this.dados.selected).then(response => {
                    console.log(response);
                    this.dados.loading = false;
                    toastr({
                        title: response.message,
                        icon: response.status,
                    });
                    if (response.status != 'success') return
                    this.$store.dispatch('getUserData');
                    this.$router.push('/');
                })
            },
        }
    };
</script>

<style scoped>
    .slick-dots {
        position: initial !important;
    }

    .btn-primary {
        background-color: #5976e0 !important;
        border-color: #5976e0 !important;
    }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
    .errPage-container {
        width: 800px;
        margin: 50px auto;

        .pan-back-btn {
            background: #008489;
            color: #fff;
            border: none !important;
        }

        .pan-gif {
            margin: 0 auto;
            display: block;
        }

        .pan-img {
            display: block;
            margin: 0 auto;
            width: 100%;
        }

        .text-jumbo {
            font-size: 60px;
            font-weight: 700;
            color: #484848;
        }

        .list-unstyled {
            font-size: 14px;

            li {
                padding-bottom: 5px;
            }
        }
    }
</style>